define('v3/Pages/AbilityGraph/ViewModels/UpdateTargetAbilityViewModel',[
	'knockout',
	'v3/Pages/AbilityGraph/Services/Backend/backendReport',
	'v3/Common/Services/Frontend/Frontend.Service',
	'v3/FromV2/utils'
], function (ko, backendReport, frontend) {
	function UpdateTargetAbilityViewModel (subjectGroupId, pupil, currentTargetPercentile, currentAbilityPercentile) {
		var self = this;

		self.pupilName = ko.observable(pupil.longName);
		self.targetPercentile = ko.observable(currentTargetPercentile);
		self.isLoading = ko.observable(false);
		self.currentAbilityPercentile = currentAbilityPercentile;

		self.descriptionMessage = Strings.UpdateTargetAbility_Description.formatRaw('<strong>{0}</strong>'.formatEncodeArguments(self.pupilName()));
		self.currentAbilityPercentileMessage = Strings.UpdateTargetAbility_ActualLevel.formatEncodeArguments(self.currentAbilityPercentile);

		self.ok = function () {
			self.isLoading(true);

			var newTargetPercentile = Math.min(self.targetPercentile(), 100);

			backendReport.updateUserTargetAbilityPercentile(subjectGroupId, pupil.userId, newTargetPercentile, false)
				.done(function (result) {
					if (result && result.success) {
						self.modal.close(newTargetPercentile, result.targetAbility, false);
					} else {
						self.modal.close();
						frontend.notification.ajax.error();
					}
				})
				.fail(function () {
					self.modal.close();
				})
				.always(function () {
					self.isLoading(false);
				});
		};

		self.cancel = function () {
			self.modal.close();
		};
	}

	return UpdateTargetAbilityViewModel;
});
